import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpecificationService {
  specificationDeletionList = new BehaviorSubject([]);
  onSpecDeleteClick = new BehaviorSubject(false);
  onSpecUpdateAndCreation = new BehaviorSubject(false);
  onShipSpecUpload = new BehaviorSubject(null);

  invoiceSpecificationDeletionList = new BehaviorSubject([]);
  onInvoiceSpecDeleteClick = new BehaviorSubject(false);
  onInvoiceSpecUpdateAndCreation = new BehaviorSubject(false);

  downloadJson(myJson: any, fileName: string) {
    const sJson = JSON.stringify(myJson);
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(sJson));
    element.setAttribute('download', `${fileName}.json`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  extractJSONfromFile(file, callback) {
    const fileReader: any = new FileReader();
    fileReader.readAsText(file, 'UTF-8');
    fileReader.onload = () => {
      callback(JSON.parse(fileReader.result));
    };
  }
}
